import { Pipe, PipeTransform } from '@angular/core';
import {DataService} from "../services/data.service";
import {EsercizioUtente} from "../models/EsercizioUtente";
import {PVenditaUtente} from "../models/PVenditaUtente";
import _ from "lodash";


export enum HasPermPerm{
   W="W",
   R="R"
}

export enum HasPermKeys{

   p_ordini_fornitore = "p_ordini_fornitore",
   p_punto_cassa = "p_punto_cassa",
   p_resi_fornitore = "p_resi_fornitore",
   p_resi_clienti = "p_resi_clienti",
   p_trasferimenti = "p_trasferimenti",
   p_vendite = "p_vendite",
   p_listini = "p_listini",
   p_dettaglio_giacenze = "p_dettaglio_giacenze",
   p_ammanchi = "p_ammanchi",
   p_impostazioni = "p_impostazioni",

   e_account = "e_account",
   e_impostazioni = "e_impostazioni",
   e_strumenti = "e_strumenti",
   e_strum_etic = "e_strum_etic",
   e_strum_listini = "e_strum_listini",
   e_strum_canali_vend = "e_strum_canali_vend",
   e_cli_for = "e_cli_for",
   e_clienti = "e_clienti",
   e_fornitori = "e_fornitori",
   e_prod_var = "e_prod_var",
   e_report = "e_report",

}


@Pipe({
   name: 'hasPerm'
})
export class HasPermPipe implements PipeTransform {

   hasPermObj = {
      // Permessi Punto Vendita
      p_ordini_fornitore: {
         pvendita_role: PVenditaUtente.PermessiPVenditaUserChoices.Gestore,
         esercizio_role: PVenditaUtente.PermessiEsercizioUserChoices.Amministrativo
      },
      p_punto_cassa: {
         pvendita_role: PVenditaUtente.PermessiPVenditaUserChoices.Venditore,
         esercizio_role: PVenditaUtente.PermessiEsercizioUserChoices.Gestore
      },
      p_resi_fornitore: {
         pvendita_role: PVenditaUtente.PermessiPVenditaUserChoices.Gestore,
         esercizio_role: PVenditaUtente.PermessiEsercizioUserChoices.Amministrativo
      },
      p_resi_clienti: {
         pvendita_role: PVenditaUtente.PermessiPVenditaUserChoices.Venditore,
         esercizio_role: PVenditaUtente.PermessiEsercizioUserChoices.Amministrativo
      },
      p_trasferimenti: {
         pvendita_role: PVenditaUtente.PermessiPVenditaUserChoices.Gestore,
         esercizio_role: PVenditaUtente.PermessiEsercizioUserChoices.Amministrativo
      },
      p_vendite: {
         pvendita_role: PVenditaUtente.PermessiPVenditaUserChoices.Venditore,
         esercizio_role: PVenditaUtente.PermessiEsercizioUserChoices.Amministrativo
      },
      p_listini: {
         pvendita_role: PVenditaUtente.PermessiPVenditaUserChoices.Gestore,
         esercizio_role: PVenditaUtente.PermessiEsercizioUserChoices.Amministrativo
      },
      p_dettaglio_giacenze: {
         pvendita_role: PVenditaUtente.PermessiPVenditaUserChoices.Venditore,
         esercizio_role: PVenditaUtente.PermessiEsercizioUserChoices.Amministrativo,
      },
      p_ammanchi: {
         pvendita_role: PVenditaUtente.PermessiPVenditaUserChoices.Manager,
         esercizio_role: PVenditaUtente.PermessiEsercizioUserChoices.Amministrativo
      },
      p_impostazioni: {
         pvendita_role: PVenditaUtente.PermessiPVenditaUserChoices.Gestore,
         esercizio_role: PVenditaUtente.PermessiEsercizioUserChoices.Amministrativo
      },

      // Permessi Esercizio
      e_account: {
         pvendita_role: PVenditaUtente.PermessiPVenditaUserChoices.NonPermesso,
         esercizio_role: PVenditaUtente.PermessiEsercizioUserChoices.Amministrativo
      },
      e_impostazioni: {
         pvendita_role: PVenditaUtente.PermessiPVenditaUserChoices.Gestore,
         esercizio_role: PVenditaUtente.PermessiEsercizioUserChoices.Amministrativo,
      },
      e_strumenti: {
         pvendita_role: PVenditaUtente.PermessiPVenditaUserChoices.Venditore,
         esercizio_role: PVenditaUtente.PermessiEsercizioUserChoices.Amministrativo
      },
      e_strum_canali_vend: {
         pvendita_role: PVenditaUtente.PermessiPVenditaUserChoices.Gestore,
         esercizio_role: PVenditaUtente.PermessiEsercizioUserChoices.Amministrativo
      },
      e_strum_etic: {
         pvendita_role: PVenditaUtente.PermessiPVenditaUserChoices.Gestore,
         esercizio_role: PVenditaUtente.PermessiEsercizioUserChoices.Amministrativo
      },
      e_strum_listini: {
         pvendita_role: PVenditaUtente.PermessiPVenditaUserChoices.Gestore,
         esercizio_role: PVenditaUtente.PermessiEsercizioUserChoices.Amministrativo
      },
      e_cli_for: {
         pvendita_role: PVenditaUtente.PermessiPVenditaUserChoices.Venditore,
         esercizio_role: PVenditaUtente.PermessiEsercizioUserChoices.Amministrativo
      },
      e_clienti: {
         pvendita_role: PVenditaUtente.PermessiPVenditaUserChoices.Venditore,
         esercizio_role: PVenditaUtente.PermessiEsercizioUserChoices.Amministrativo
      },
      e_fornitori: {
         pvendita_role: PVenditaUtente.PermessiPVenditaUserChoices.Gestore,
         esercizio_role: PVenditaUtente.PermessiEsercizioUserChoices.Amministrativo
      },
      e_prod_var: {
         pvendita_role: PVenditaUtente.PermessiPVenditaUserChoices.Gestore,
         esercizio_role: PVenditaUtente.PermessiEsercizioUserChoices.Amministrativo
      },
      e_report: {
         pvendita_role: PVenditaUtente.PermessiPVenditaUserChoices.Gestore,
         esercizio_role: PVenditaUtente.PermessiEsercizioUserChoices.Amministrativo
      }
   }

   hasPerm(permReq: "W" | "R", permUser: "W" | "R"){
      return false
   }

   constructor(private dataSrv:DataService) {}

   transform(...args: any[]): any {
      // console.log("args")
      // console.log(args)

      let keys = args[0]
      let permObjPV: PVenditaUtente | [PVenditaUtente] | undefined = args[1]
      let permObjES: EsercizioUtente = this.dataSrv.esercizioUser

      let permessi = keys
      if(!_.isArray(keys)){
         permessi = [keys]
      }

      if(!keys || !permessi?.length){
         console.error(keys)
         console.error("Permesso non meglio specificato...")
         console.groupEnd()
         return true
      }

      for (const k of permessi){
         if (!this.hasPermObj[k]){
            console.error(`Chiave '${k}' mancante...`);
            continue
         }

         let permReqPV = this.hasPermObj[k]["pvendita_role"]
         let permReqES = this.hasPermObj[k]["esercizio_role"]

         if (permObjPV){
            if (permObjPV instanceof PVenditaUtente && permObjPV.data["pvendita_role"]) {
               if (permObjPV.data["pvendita_role"] >= permReqPV)
                  return true;
            }
            else if (permObjPV instanceof Array && permObjPV.length){
               if (permObjPV.some(e => e instanceof PVenditaUtente && e.data["pvendita_role"] && e.data["pvendita_role"] >= permReqPV))
                  return true;
            }
         }

         if (permObjES.data["esercizio_role"]) {
            if (permObjES.data["esercizio_role"] >= permReqES)
               return true;
         }
      }

      if(this.dataSrv.user.IsAdmin){
         return true
      }

      return false;
   }

}
